export const getActiveSpan = (colProps: any, screens: any) => {
  const order = ["xxl", "xl", "lg", "md", "sm", "xs"];
  for (let key of order) {
    if (screens[key] && colProps[key] !== undefined) {
      return colProps[key];
    }
  }
  return colProps.span || 24;
};
